import { ChangeDetectionStrategy, Component, computed, inject, input, model, OnInit } from '@angular/core';
import { ProductType, GetProductsRequestPost, Product, ProductsUtils } from '../../common';
import { ProductsService } from '../../services';

@Component({
    selector: 'ca-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProductsService],
    standalone: false
})
export class ProductCardComponent implements OnInit {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    product = model<Product>();
    productId = model<string>();
    noProductText = input<string>('PRODUCT_CARD.NO_PRODUCT');
    showAllProductsButtonText = input<string>('PRODUCT_PICKER.BUTTON.SHOW_ALL');
    productPickerHeaderText = input<string>('PRODUCT_PICKER.TITLE');
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    productType = input<ProductType>();
    singleProduct = computed(() => this.productsService.products()?.[0]);
    productsService = inject(ProductsService);

    ngOnInit(): void {
        this.readProduct();
    }

    onProductSelected(products: Product[]): void {
        this.product.set(products[0]);
    }

    onProductRemoved(): void {
        this.product.set(undefined);
        this.productId.set(undefined);
        this.productsService.products.set([]);
    }

    readProduct(): void {
        const productId = this.productId();
        if (!productId) {
            return;
        }

        this.productsService.readProducts({
            languageCode: this.languageCode(),
            countryCode: this.countryCode(),
            pageSize: 1,
            pageIndex: 0,
            productIDs: [productId]
        });
    }
}
